import { Node as ProseNode } from 'prosemirror-model'

export const wordCountOfDoc = (doc: ProseNode) => {
  const textContent = doc.textBetween(0, doc.nodeSize - 2, ' ')

  return `${
    textContent
      ?.trim()
      .split(' ')
      .filter((tc) => tc.length).length
  }`
}
